module.exports = __webpack_public_path__ + "static/media/sunny_days.ff313ed6.svg";